import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1315df3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "accounts-table-wrapper select-accounts"
};
const _hoisted_2 = {
  class: "accounts-table-wrapper"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "select-accounts"
}, " Here is the list of available advertiser profiles not already connected to Omny. ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "select-accounts-detail"
}, " If you cannot find the right advertiser, please close this windows and restart the connection process with a user having access to it or contact your account administrator to request access before trying to connect it to Omny. ", -1));
const _hoisted_8 = {
  class: "select-advertiser"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "Select advertisers", -1));
const _hoisted_10 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_11 = {
  class: "table-body-product-text-wrapper"
};
const _hoisted_12 = {
  class: "table-body-product-text-wrapper dsp"
};
const _hoisted_13 = {
  class: "dsp-id"
};
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
  class: "table-body-product-text-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_page_title = _resolveComponent("app-page-title");
  const _component_connection_failed = _resolveComponent("connection-failed");
  const _component_app_table_head = _resolveComponent("app-table-head");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_app_td = _resolveComponent("app-td");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_connection_success = _resolveComponent("connection-success");
  return _openBlock(), _createElementBlock(_Fragment, null, [$data.loadingData ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading Profiles Data... ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [!$data.showSuccessMessage && !$data.showFailedMessage ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_app_page_title, {
    title: $data.title,
    action: "Validate",
    onAction: $options.onValidate,
    visibleButton: true
  }, null, 8, ["title", "onAction"]), _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7])) : _createCommentVNode("", true), $data.showFailedMessage ? (_openBlock(), _createBlock(_component_connection_failed, {
    key: 1,
    title: $data.title,
    "error-title": $data.errorTitle,
    "error-detail": $data.errorDetail,
    supportText: $data.supportText
  }, null, 8, ["title", "error-title", "error-detail", "supportText"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_hoisted_9, $data.accounts.length ? (_openBlock(), _createBlock(_component_b_table_simple, {
    key: 0,
    "sticky-header": "",
    striped: "",
    "table-class": "accounts-table table-wrapper "
  }, {
    default: _withCtx(() => [_createVNode(_component_app_table_head, {
      style: {
        "background": "#f7f7f7"
      },
      fields: $options.tableFields,
      onSelectAll: $options.selectAll
    }, null, 8, ["fields", "onSelectAll"]), _createVNode(_component_b_tbody, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.accounts, item => {
        return _openBlock(), _createBlock(_component_b_tr, {
          key: item.seller_id,
          onClick: $event => $options.onRowSelect(item)
        }, {
          default: _withCtx(() => [_createVNode(_component_app_td, {
            class: "table-body-checkbox-wrapper border-table-row"
          }, {
            default: _withCtx(() => [!$data.showFailedMessage ? (_openBlock(), _createBlock(_component_b_form_checkbox, {
              key: 0,
              modelValue: item.isSelected,
              "onUpdate:modelValue": $event => item.isSelected = $event,
              disabled: $options.selectedAccounts.length >= $data.selectLimit && !item.isSelected
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(item.advertiserId), 1)]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, _toDisplayString(item.dspProfileName), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.dspProfileId), 1)])]),
            _: 2
          }, 1024), _createVNode(_component_app_td, {
            class: "table-body-product-wrapper border-table-row flag",
            align: "center"
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "country-flag flag-wrapper",
              src: $options.getFlagForMarketPlace(item.country),
              alt: item.country
            }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, _toDisplayString($options.flipCountry(item.country)), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)]), $data.showSuccessMessage ? (_openBlock(), _createBlock(_component_connection_success, {
    key: 2,
    title: $data.successTitle,
    detail: $data.successDetail
  }, null, 8, ["title", "detail"])) : _createCommentVNode("", true)])], 64);
}